import React from "react";
import { useTranslation } from "react-i18next";
import moment, { Moment } from "moment";

// MUI
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

// MUI Icons
import EventIcon from "@mui/icons-material/Event";

// Custom
import { formats } from "@/lib/formats";

// Types
type FormHeadingDateProps = {
  date?: Moment | null
}

function FormHeadingDate(props: FormHeadingDateProps) {
  const { t } = useTranslation();

  const { date } = props;

  return (
    <Tooltip title={t("hps.izleti.prvi_dan") as string}>
      <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
        <EventIcon style={{ marginRight: 8 }} />
        <Typography align="left" variant="subtitle2" className="nodrag">
          { date ? moment.utc(date).local().format(formats.date) : "??"}
        </Typography>
      </div>
    </Tooltip>
  );
}

export default FormHeadingDate;
